const useModalPortalElement = (): HTMLElement | null => {
  // When pre-rendering document will not be defined. We can return null knowing that a client-side render should work.
  // Encountered error "#<ExecJS::ProgramError: ReferenceError: document is not defined>" when prerendering ...
  // Note, if trying to debug this, you must restart rails (not yarn) as rails is most likely being used to SSR the page that needs this hook.
  if (typeof document === 'undefined') {
    return null;
  }

  return document.getElementById('modalPortal');
};

export default useModalPortalElement;
